// extracted by mini-css-extract-plugin
export default {"Container":"Footer_Container__+qAL6","Footer":"Footer_Footer__gSSMv","Total":"Footer_Total__TKbQo","Active":"Footer_Active__HL0pp"};